export const config = {
	sheet: {
		height: '48px',
		dark: true
	},
	innerSheet: {
		color: 'transparent',
		class: 'd-flex align-center'
	},
	tabs: {
		backgroundColor: 'transparent'
	},
	tab: {
		exact: true
	}
};
